import { render, staticRenderFns } from "./DocumentNumberItem.vue?vue&type=template&id=2a836a5f&"
import script from "./DocumentNumberItem.vue?vue&type=script&lang=ts&"
export * from "./DocumentNumberItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports